module.exports = __webpack_public_path__ + "static/006_Room-94e1bf21e055fdcfd5c27eb220ce0df4.jpg";